import { api_ai_alert_subscription_path, api_ai_alert_subscriptions_path } from '@routes';

import type { AiThread } from './aiThread';
import request from './request';

export interface AiAlertSubscription {
  aiThread: AiThread;
  createdAt: string;
  id: number;
  updatedAt: string;
  unsubscribedAt: string;
}

export interface AiAlertSubscriptionsParams {
  includeUnsubscribed?: boolean;
  aiThreadId?: string;
}

export interface CreateAiAlertSubscriptionParams {
  aiThreadId: string;
}

export interface AiAlertSubscriptionsResponse {
  aiAlertSubscriptions: AiAlertSubscription[];
}

export async function getAiAlertSubscriptions({
  includeUnsubscribed = false,
  aiThreadId,
}: AiAlertSubscriptionsParams): Promise<AiAlertSubscriptionsResponse> {
  const resp = await request(
    'get',
    api_ai_alert_subscriptions_path({
      include_unsubscribed: includeUnsubscribed,
      ai_thread_id: aiThreadId,
    })
  );
  return resp;
}

export interface UpdateAiAlertSubscriptionParams {
  id: number;
  unsubscribedAt: Date;
}

export async function updateAiAlertSubscription({
  id,
  unsubscribedAt,
}: UpdateAiAlertSubscriptionParams): Promise<AiAlertSubscription> {
  const resp = await request('patch', api_ai_alert_subscription_path(id), {
    ai_alert_subscription: {
      unsubscribed_at: unsubscribedAt,
    },
  });
  return resp;
}

export async function createAiAlertSubscription({
  aiThreadId,
}: CreateAiAlertSubscriptionParams): Promise<AiAlertSubscription> {
  const resp = await request('post', api_ai_alert_subscriptions_path(), {
    ai_alert_subscription: {
      ai_thread_id: aiThreadId,
    },
  });
  return resp;
}
